import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Masonry from "@mui/lab/Masonry";
import { GetPostsByPage } from "../../lib/graphql/queries/wordpress/posts.graphql";
import { GetPostsByPageQuery } from "../../lib/graphql/codegen/generated-client-wp";
import { PageContainer } from "../../components/Layout/PageContainer";
import PostPreview from "./postPreview";
import React, { useCallback, useState } from "react";
import { useQuery } from "@apollo/client";

import { useTranslation } from "react-i18next";
import Seo from "../../components/others/Seo";
export default function Articles() {
  const theme = useTheme();
  const { t } = useTranslation();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const [loadingMore, setloadingMore] = useState(true);
  const { data, fetchMore, error } = useQuery<GetPostsByPageQuery>(
    GetPostsByPage,
    {
      onCompleted: () => setloadingMore(false),
    }
  );

  const fetchMorePosts = useCallback(() => {
    if (data?.posts?.pageInfo?.hasNextPage) {
      setloadingMore(true);
      fetchMore({
        variables: { after: data?.posts?.pageInfo?.endCursor },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return {
            posts: {
              pageInfo: fetchMoreResult.posts?.pageInfo,
              edges: [
                ...(previousResult.posts?.edges ?? []),
                ...(fetchMoreResult.posts?.edges ?? []),
              ],
            },
          };
        },
      });
    }
  }, [data, fetchMore]);

  const postCards =
    (data &&
      data.posts?.edges.map(({ node }, index) => {
        return <PostPreview key={index} node={node} />;
      })) ||
    [];
  return (
    <PageContainer>
      <Seo
        title={t("page_blog.seo.title") && undefined}
        description={t("page_blog.seo.description") ?? undefined}
      />
      <Stack
        sx={{
          background: theme.palette.background.layout,
          alignItems: "center",
          width: "100%",
        }}
      >
        <Stack maxWidth="lg" width="100%">
          <Typography
            variant="h3"
            align="center"
            gutterBottom
            sx={{
              py: 3,
              color: theme.palette.primary.contrastText,
              fontWeight: theme.typography.fontWeightMedium,
            }}
          >
            {t("page_blog.title")}
          </Typography>
          {matches ? (
            <Masonry
              columns={{ sm: 2, md: 3, lg: 4 }}
              spacing={{ sm: 2, md: 3, lg: 3 }}
            >
              {postCards}
            </Masonry>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              {postCards.map((postCard) => (
                <Box key={postCard.key} sx={{ mb: 2 }}>
                  {postCard}
                </Box>
              ))}
            </Box>
          )}

          {loadingMore ? (
            <CircularProgress sx={{ alignSelf: "center", m: 5 }} />
          ) : (
            data?.posts?.pageInfo?.hasNextPage && (
              <Button
                variant="contained"
                sx={{ alignSelf: "center", my: 3 }}
                onClick={fetchMorePosts}
              >
                {"Voir plus d'articles"}
              </Button>
            )
          )}
        </Stack>
      </Stack>
    </PageContainer>
  );
}
export async function getStaticProps() {
  // const posts = await apolloWpClient.query<GetAllPostsQuery>({
  //   query: GetAllPosts,
  // });
  // return {
  //   props: {
  //     data: posts.data || [],
  //   },
  // };
  return { props: {} };
}
